<!-- 少数处理方式 -->
<template>
  <BaseFormItem2
    :label="fields.label"
    :labelTips="fields.labelTips"
    :fillTips="fillTips"
    :isError="isError"
    :isErrorBlink="isErrorBlink"
    :isShake="isShake"
    :isShowNewIcon="isShowNewIcon"
    :valueConfig="{ key: 'lack_handle_type', width: 311, trigger: 'manual' }"
  >
    <BaseRadioGroup2 v-model="val.lack_handle_type" :isError="isError">
      <el-radio-button
        v-for="item in fields.options"
        :key="item.value"
        :label="item.value"
        @click.native.prevent="handleRadioClick(item.value)"
      >{{ item.label }}</el-radio-button>
    </BaseRadioGroup2>
    <div v-if="val.lack_handle_type == 2" class="lack_handle_type__value">
      <i class="lack_handle_type__value__linker"></i>
      <div class="lack_handle_type__value__content">
        <span>
          {{ lackHandleText }}
        </span>
        <BaseTextButton @click="handleOpenDialog">修改</BaseTextButton>
      </div>
    </div>
    <!-- 少数默认补料弹框 -->
    <LackHandleTypeDialog 
      ref="lackHandleTypeDialogRef" 
      @confirm="handleConfirm"
    />
  </BaseFormItem2>
</template>

<script>
import LackHandleTypeDialog, { getLackHandleText } from '@@/views/pcb/components/lackHandleTypeDialog'

import { getFR4Fields } from '@@/utils/getFields'

export default {
  props: {
    // 少数处理方式
    lack_handle_type: {
      type: [String, Number],
      default: ''
    },
    // 少数订单数量
    lack_handle_number_type: {
      type: [String, Number],
      default: ''
    },
    // 少数占比大于
    lack_handle_number: {
      type: [String, Number],
      default: ''
    },
    // 少数补料数量单位
    lack_handle_number_unit: {
      type: [String, Number],
      default: ''
    },
    // 少数发货类型
    lack_handle_shipping_type: {
      type: [String, Number],
      default: ''
    },
    // 出货形式
    units: {
      type: Number,
      default: 1
    },
    // 板子数量
    bcount: {
      type: [String, Number],
      default: ''
    },
    // 拼版规则y
    layouty: {
      type: [String, Number],
      default: 1
    },
    // 拼版规则x
    layoutx: {
      type: [String, Number],
      default: ''
    }
  },
  components: {
    LackHandleTypeDialog
  },
  data() {
    return {
      val: {
        lack_handle_type: this.lack_handle_type, // 少数处理方式 0-不设置  1-少数默认退款  2-少数默认补料
        lack_handle_number_type: this.lack_handle_number_type, // 少数订单数量 1-按百分比 2-按订单数 3-完全不接受少数
        lack_handle_number: this.lack_handle_number, // 少数占比大于(按百分比时小数，其余整数)
        lack_handle_number_unit: this.lack_handle_number_unit, // 少数补料数量单位： 1-% 2-pcs 3-set
        lack_handle_shipping_type: this.lack_handle_shipping_type, // 少数发货类型 1-和订单一起发货 2-少数单独发货
      },
      options: {
        lack_handle_number_type: {
          1: '按百分比',
          2: '按订单数',
          3: '完全不接受少数'
        },
        lack_handle_number_unit: { 1: '%', 2: 'Pcs', 3: 'Set' },
        lack_handle_shipping_type: {
          1: '和订单一起发货',
          2: '少数单独发货'
        }
      },
      isError: false, // 是否显示错误提示样式
      isErrorBlink: false, // 是否显示错误提示样式且闪两下
      isShake: false, // 是否抖动两下
    }
  },
  computed: {
    fields() {
      return getFR4Fields('lack_handle_type')
    },
    lackHandleText() {
      const { val } = this
      if (val.lack_handle_type != 2) return ''
      return getLackHandleText(val)
    },
    // 是否显示 NEW 标识
    isShowNewIcon() {
      return new Date().getTime() <= new Date('2025-10-04').getTime()
    },
    fillTips() {
      const { val } = this
      return !val.lack_handle_type && val.lack_handle_type !== 0
    }
  },
  watch: {
    lack_handle_type(newVal) {
      this.val.lack_handle_type = newVal
    },
    lack_handle_number_type(newVal) {
      this.val.lack_handle_number_type = newVal
    },
    lack_handle_number(newVal) {
      this.val.lack_handle_number = newVal
    },
    lack_handle_number_unit(newVal) {
      this.val.lack_handle_number_unit = newVal
    },
    lack_handle_shipping_type(newVal) {
      this.val.lack_handle_shipping_type = newVal
    }
  },
  methods: {
    handleEmit(keys) {
      (Array.isArray(keys) ? keys : [keys]).forEach(key => {
        this.$emit(`update:${key}`, this.val[key])
      })
      this.isShowError(false)
    },
    handleRadioClick(lack_handle_type) {
      if (this.val.lack_handle_type === lack_handle_type) return
      // 当选择 少数默认补料，且没设置相关参数时显示弹框，否则直接选择
      if (lack_handle_type === 2 && !this.val.lack_handle_number_type) {
        this.handleOpenDialog()
      } else {
        // 切换到别的选项时，清空 少数默认补料相关参数
        // this.val = Object.assign(this.val, { 
        //   lack_handle_type,
        //   lack_handle_number_type: '',
        //   lack_handle_number: '',
        //   lack_handle_number_unit: '',
        //   lack_handle_shipping_type: ''
        // })
        // this.handleEmit(Object.keys(this.val))
        this.val.lack_handle_type = lack_handle_type
        this.handleEmit('lack_handle_type')
      }
    },
    // 显示弹框
    handleOpenDialog() {
      const { bcount, units, layoutx, layouty } = this
      if (!bcount) {
        this.$message.warning('请先选择板子数量')
        return
      }
      this.$refs.lackHandleTypeDialogRef.open({ ...this.val, bcount, units, layoutx, layouty })
    },
    // 确认
    handleConfirm(val) {
      this.val = Object.assign(this.val, { ...val, lack_handle_type: 2 })
      this.handleEmit(Object.keys(this.val))
    },
    // 是否显示错误提示样式
    isShowError(isError) {
      this.isError = isError
    },
    // 是否抖动两下
    isShowShake(isShake) {
      this.isShake = isShake
      const timer = setTimeout(() => {
        this.isShake = false
        clearTimeout(timer)
      }, 300)
    },
  }
}
</script>

<style lang="scss" scoped>
@import '~@@/styles/mixin.scss';

.lack_handle_type__value {
  position: relative;
  margin-top: 6px;
  padding: 4px 12px;
  width: 291px;
  border-radius: 3px;
  background-color: $--background-hover;
  .lack_handle_type__value__linker {
    @include moduleLinkerMixin(13px, vertical, dark);
    position: absolute;
    top: -10px;
    left: 193px;
  }
  .lack_handle_type__value__content {
    display: flex;
    justify-content: space-between;
    align-items: center;
    .base-text-button {
      background-color: #fff;
      &:hover {
        border-color: $--form-color-base;
        background-color: #fff;
      }
    }
  }
}
</style>